/** §13.5: first tab stop on every page jumps past the header to `#main`. */
import { useIntl } from '@windrop/ui';

export const MAIN_ID = 'main';

export function SkipLink() {
  const { t } = useIntl();
  return (
    <a className="skip-link" href={`#${MAIN_ID}`}>
      {t('shell.skip', {}, 'Skip to main content')}
    </a>
  );
}
